/**
 * @name Actions
 * @description Botones de acciones CRUD del datagrid
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

import { Icons, MUI } from '@styles';

// Acciones CRUD
const Actions = (props) => {
  const {
    canAdd,
    canEdit,
    canDelete,
    canCancel,
    canSelectMultiple,
    selectedRows,
    selectedRowsLength,
    onAdd,
    onEdit,
    onDelete,
    onCancel
  } = props;

  return (
    <Styled.FlexActions>
      {/* Añadir */}
      {canAdd && (
        <MUI.Tooltip title={i18n.t('GenericMessages.add')}>
          <Styled.ButtonFAB
            aria-label="add"
            isLast={!(canEdit || canDelete || canCancel)}
            onClick={onAdd}
          >
            <Icons.Add />
          </Styled.ButtonFAB>
        </MUI.Tooltip>
      )}

      {/* Editar */}
      {canEdit && (
        <MUI.Tooltip title={i18n.t('GenericMessages.edit')} disableHoverListener={canSelectMultiple ? selectedRowsLength < 1 : selectedRowsLength !== 1}>
          <Styled.ButtonFAB
            aria-label="edit"
            isLast={!(canDelete || canCancel)}
            disabled={canSelectMultiple ? selectedRowsLength < 1 : selectedRowsLength !== 1}
            onClick={() => onEdit(selectedRows)}
          >
            <Icons.Edit />
          </Styled.ButtonFAB>
        </MUI.Tooltip>
      )}

      {/* Eliminar */}
      {canDelete && (
        <MUI.Tooltip title={i18n.t('GenericMessages.delete')} disableHoverListener={selectedRowsLength === 0}>
          <Styled.ButtonFAB
            aria-label="delete"
            isLast={!canCancel}
            disabled={selectedRowsLength === 0}
            onClick={() => onDelete(selectedRows)}
          >
            <Icons.Delete />
          </Styled.ButtonFAB>
        </MUI.Tooltip>
      )}

      {/* Cancelar */}
      {canCancel && (
        <MUI.Tooltip title={i18n.t('DialogConfirm.cancel')} disableHoverListener={canSelectMultiple ? selectedRowsLength < 1 : selectedRowsLength !== 1}>
          <Styled.ButtonFAB
            color="secondary"
            aria-label="cancel"
            isLast={true}
            disabled={canSelectMultiple ? selectedRowsLength < 1 : selectedRowsLength !== 1}
            onClick={() => onCancel(selectedRows)}
          >
            <Icons.Block />
          </Styled.ButtonFAB>
        </MUI.Tooltip>
      )}
    </Styled.FlexActions>
  );
};

Actions.propTypes = {
  // Boolean que indica si debe ocultar / mostrar el botón de añadir.
  canAdd: PropTypes.bool,
  // Boolean que indica si debe ocultar / mostrar el botón de editar.
  canEdit: PropTypes.bool,
  // Boolean que indica si debe ocultar / mostrar el botón de eliminar.
  canDelete: PropTypes.bool,
  // Boolean que indica si debe ocultar/mostrar el botón de cancelar.
  canCancel: PropTypes.bool,
  // Boolean que indica si se puede tener una multiple selección de elementos para editar.
  canSelectMultiple: PropTypes.bool,
  // Registros seleccionados.
  selectedRows: PropTypes.array,
  // Número de registros seleccionados.
  selectedRowsLength: PropTypes.number,
  // Función a ejecutar cuando se agregará un elemento nuevo, al invocarla es necesario pasar como argumento event.
  onAdd: PropTypes.func,
  // Función a ejecutar cuando se editará un elemento, al invocarla es necesario pasar como argumento event.
  onEdit: PropTypes.func,
  // Función a ejecutar cuando se desea eliminar elementos, al invocarla es necesario pasar como argumento event.
  onDelete: PropTypes.func,
  // Función a ejecutar cuando se desea cancelar elementos, al invocarla es necesario pasar como argumento event.
  onCancel: PropTypes.func,
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.FlexActions = styled.div`
  display: flex;
  flex-basis: 200px;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-end;
`;

Styled.ButtonFAB = styled(MUI.ButtonFAB)`
  &.MuiFab-root {
    margin: ${(props) => props.isLast ? '8px 0px 8px 8px' : '8px'};
  }
`;

Styled.LastButtonFAB = styled(MUI.ButtonFAB)`
  &.MuiFab-root {
    margin: 8px 0px 8px 8px;
  }
`;

export default Actions;